<template lang="html">
  <modal-template
    ref="modal"
    size="lg"
    title="Relatório de Indicações"
    type-modal="report_lead_modal"
  >
    <div class="modal-content__main">
      <d-form-row class="w-100">
        <d-col cols="auto" class="d-flex mb-4 mb-sm-0 justify-content-start">
          <d-input-group class="d-flex justify-content-left">
            <d-datepicker v-model="pagination.date_from" placeholder="Data inicial" typeable/>
            <d-datepicker v-model="pagination.date_to" placeholder="Data final" typeable/>
            <d-input-group-text slot="append">
            <i class="material-icons">&#xE916;</i>
            </d-input-group-text>
          </d-input-group>
        </d-col>
        <d-col>
          <div class="input-group input-group-seamless ">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fas fa-search"></i>
              </div>
            </div>
              <input
                class="navbar-search form-control"
                type="text"
                placeholder="Procurar por algo..."
                aria-label="Search"
                v-model="pagination.search"
                >
            </div>
        </d-col>
      </d-form-row>
      <div class="table-overflow">
        <lead-table :leads="leads.list" />
      </div>
      <pagination :total-items="leads.total_items" :pagination.sync="pagination"></pagination>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="close()"
        class="btn btn-sm btn-secondary mr-3"
      >Cancelar</d-button>
      <d-button
        type="button"
        @click="exportCsv()"
        class="btn btn-sm btn-primary"
      >Exportar CSV</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import { downloadCsvFile, catchPdf } from '_utils';
import Events from '_utils/events';
import LeadService from '_services/rest/modules/lead';
import ModalTemplate from '_shared/Modal.vue';
import Pagination from '_shared/Pagination.vue';
import LeadTable from '_modules/lead/components/LeadListTable.vue';
import { _REPORT_RESELLER_LEAD_ } from '../ResellerModel';

export default {
  name: 'report-reseller',
  components: {
    Pagination,
    ModalTemplate,
    LeadTable,
  },
  props: {},
  data() {
    return {
      pagination: {
        date_from: null,
        date_to: null,
        search: '',
        reseller: null,
        skip: 0,
        take: 10,
        page: 1,
      },
    };
  },
  computed: {
    leads() {
      const { leadList } = this.$store.state.lead;
      if (leadList && leadList.list.length) {
        return leadList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getLeadList',
    ]),
    close() {
      this.setToggle({ type: 'report_lead_modal', bool: false });
    },
    exportCsv() {
      LeadService.download(this.pagination)
        .then(response => downloadCsvFile(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }));
    },
    getList() {
      this.getLeadList(this.pagination);
    },
  },
  mounted() {
    Events.$on(_REPORT_RESELLER_LEAD_, reseller => {
      this.pagination.reseller = reseller.id;
      this.getList();
    });
    Events.$on('update:pagination', () => {
      this.getList();
    });
  },
};
</script>


<style lang="scss">
@media (min-width: 992px) {
  .modal-lg {
    max-width: 1300px;
  }
}
@media (max-width: 991px) {
  .modal-lg {
    max-width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
